
const ja_JP = {
  "产品菜单": "製品",
  "关于我们菜单": "私たちについて",
  "帮助中心菜单": "ヘルプセンター",
  "信用基础": "信用を基盤に",
  "加密支付": "暗号化決済",
  "全币种支持": "全通貨対応",
  "全节点承兑": "フルノード引受",
  "去中心担保": "分散型担保",
  "立即开始使用": "今すぐ始める",
  "闪电般的支付体验": "瞬速の決済体験",
  "完成跨境支付": "45秒以内に国際送金を完了",
  "多链支持": "マルチチェーン対応",
  "支持主流公链资产": "主要パブリックチェーン資産をサポート",
  "实时结算": "リアルタイム決済",
  "无需等待": "秒速到着、待機不要",
  "超额担保": "超過担保",
  "资金安全有保障": "資金の安全を保証",
  "一个钱包": "一つのウォレット",
  "所有可能": "すべての可能性",
  "商户收款": "加盟店収款",
  "全球化支付网关": "グローバル決済ゲートウェイ",
  "承兑服务": "引受サービス",
  "稳定可靠的承兑网络": "安定した信頼性の高い引受ネットワーク",
  "数字资产": "デジタル資産",
  "多链资产管理": "マルチチェーン資産管理",
  "下载": "アプリダウンロード",
  "多节点承兑": "マルチノード引受",
  "生态": "NECOエコシステム",
  "钱包": "TEPAYウォレット",
  "立即下载": "今すぐダウンロード",
  "随时汇币": "いつでもどこでも暗号通貨決済、国際送金はもう難しくない",
  "走天下": "世界中を歩く",
  "海量订单": "膨大な注文数",
  "日进斗金": "日々莫大な利益",
  "首页描述": "TePayは分散型の信用決済インフラストラクチャであり、銀行ではありません。金融サービスは当社のアクセプターノードネットワークとブロックチェーンベースのスマートコントラクトネットワークによってサポートされています。担保と信用メカニズムにより安全で準拠した取引が保証され、エスクローと紛争解決は当社のDAO仲裁システムによって管理されます。マルチチェーン相互運用性と統合コンプライアンスモジュールにより、ユーザーと商家の両方にシームレスで透明性のある決済体験を提供します。",
  "轻松交易": "簡単な取引",
  "slide2Text": "TePayの分散型マルチノードネットワークを通じて、法定通貨とデジタル通貨の自由でシームレスな交換を実現",
  "slide2Info": "TePayは分散型決済プラットフォームであり、伝統的な銀行ではありません。サービスは当社のマルチノード引受ネットワークによって提供され、ブロックチェーンスマートコントラクトによって保証されます。超過担保と信用スコアリングメカニズムにより、すべての取引が準拠かつ安全であることを保証します。",
  "全球通用": "グローバル対応",
  "让每一笔支付": "すべての決済を",
  "瞬间达成": "瞬時に完了",
  "slide3Text": "TePayの強力なネットワークで、法定通貨とデジタル通貨を自由に取引",
  "slide3Info": "TePayは単一通貨に限定されません。当社の分散型プラットフォームでは、複数の通貨を簡単に送信、受信、交換でき、国境の制限を打破し、統一された体験を楽しめます。ブロックチェーン技術と動的信用メカニズムにより、資金は常に安全かつ効率的に運用されます。",
  "护航每笔交易": "すべての取引を護衛",
  "去中心化担保": "分散型担保",
  "安全无忧": "安全安心",
  "slide4Text": "分散型担保メカニズムを通じて、すべての取引に信頼保証と安全サポートを提供",
  "slide4Info": "TePayは伝統的な銀行ではなく、分散型担保メカニズムを通じて取引の安全を確保します。当社のシステムは超過担保、動的信用スコアリング、DAO仲裁を利用し、すべての取引に堅実な保証を提供します。この強力な担保メカニズムは伝統金融とデジタル資産を効果的に接続し、すべての決済が準拠、安全、効率的であることを保証します。",
  "一个钱包走天下": "一つのウォレットで世界中を歩く",
  "币随时付": "暗号通貨はいつでも支払い可能",
  "跨境无忧": "国際送金の心配なし",
  "slide5Text": "すべての資産を一元管理、法定通貨でもデジタル通貨でも、一つの安全なウォレットに",
  "slide5Info": "TePayはあなたの金融世界を一体化し、一つのウォレットですべての決済ニーズを解決します。当社のプラットフォームは資産管理とグローバル取引を統合し、先進的なブロックチェーン技術と動的信用メカニズムに依拠して、シームレスで効率的な金融体験を提供します。",
  "slide6Text": "加盟店と顧客の多様な通貨ニーズに対応し、無限の利益を獲得",
  "slide6Info": "TePayの動的マッチングエンジンは法定通貨と暗号通貨の間の障壁を打破し、引受ノードが加盟店と顧客のどちらの通貨を採用する場合でも利益を実現できるようにします。プラットフォームは効率的に決済し、すべての取引が収益倍増を支援します。",
  "边兑边赚": "交換しながら稼ぐ",
  "信用随行": "信用が随行",
  "slide7Text": "毎回の交換で収益が倍増し、同時に信用が着実に向上",
  "slide7Info": "TePayは伝統的な銀行ではなく、分散型担保メカニズムを通じて取引の安全を確保します。当社のシステムは超過担保、動的信用スコアリング、DAO仲裁を利用し、すべての取引に堅実な保証を提供します。この強力な担保メカニズムは伝統金融とデジタル資産を効果的に接続し、すべての決済が準拠、安全、効率的であることを保証します。",
  "下载TEPAY": "TEPAYをダウンロード",
  "开启信用支付": "信用決済を開始",
  "多币种支持": "多通貨対応",
  "多节点承兑描述": "マルチノード引受",
  "下载Text": "ダウンロード",
  "链上赋能": "オンチェーン賦能 コミュニティEC",
  "品牌即社区": "ブランドはコミュニティ",
  "消费即投资": "消費は投資",
  "本地即全球": "ローカルはグローバル",
  "首页描述": "NECO（来客）コミュニティECプラットフォームは、Web3分散型信頼フレームワークを基盤とし、実消費とオンチェーン透明還元を深く融合させ、ユーザー、加盟店、コミュニティの価値循環を再構築し、共有、信頼、持続可能な新たなECパラダイムを开创します。",
  "真实消费": "実消費",
  "支撑返利": "還元を支える",
  "slide2Text": "多く買うほど、還元はより真実に",
  "slide2Info": "NECOは注文が完了しオンチェーン確認された後にのみ、対応する債券とポイントを生成します。還元額は厳密に商家の値引き20%に連動し、一切の過剰発行はありません。これはプラットフォームの全報酬が真実のキャッシュフローによって支払われ、ユーザーが目にするすべてのNECO/USAIがブロックエクスプローラーで追跡可能であることを意味し、「資金盤」リスクを完全に遮断します。",
  "透明积分": "透明なポイント",
  "代币经济": "トークンエコノミー",
  "slide3Text": "ポイントのオンチェーン化、価値の検証可能",
  "slide3Info1": "消費還元はNECOプラットフォームトークンとUSAIステーブルコインの2つの元帳に分割されます：",
  "slide3Info2": "前者は每日0.2%の線形解放、後者は消滅／鋳造に伴い為替レートを自動バランス。",
  "slide3Info3": "すべての鋳造、消滅、解放イベントはスマートコントラクトによって記録され、誰でもウォレット残高、解放カウントダウン、取引履歴をリアルタイムで確認でき、あらゆるインセンティブが公開の「身分証明書」を持つようにします。",
  "多角色": "マルチロール",
  "激励生态": "インセンティブエコシステム",
  "slide4Text1": "ユーザー、リーダー、加盟店、Win-Winの閉ループ",
  "slide4Info1": "ユーザー：消費100%ポイント還元、NECO保有で値上がり益とガバナンス権を享受；",
  "slide4Info2": "リーダー：グループ購入の組織、コミュニティ運営、コミッション+NECO追加報酬を獲得；",
  "slide4Info3": "加盟店：値引きで精密注文と交換、0手数料決済とブランド露出を享受。",
  "slide4Info4": "三方の収益はすべて同一のオンチェーン数式に記録され、収入と支出はリアルタイムで照合され、自己駆動型の分裂循環を形成します",
  "合规保障": "コンプライアンス保証",
  "全程可审": "全行程監査可能",
  "slide5Text": "オンチェーン痕跡残存、規制当局に優しい",
  "slide5Info1": "TePayゲートウェイはKYC、法定通貨接続と決済コンプライアンスを担当します。取引データ、値引き比率、ポイント分配はすべてオンチェーン記録されます。",
  "slide5Info2": "プラットフォームはまた、デュアルオラクル、価格バッファーゾーンとDAOリスク管理基金を設置し、極端な相場状況や政策変更が発生した場合、ガバナンス投票によって速度制限、買い戻しまたは一時停止メカニズムを発動できます——規制当局に安心、ユーザーに安心、エコシステムを長寿にします。",
  "合作伙伴": "パートナー",
  "社区团购": "コミュニティ団体購入",
  "社区小店": "コミュニティ小店",
  "社区空间": "コミュニティスペース",
  "社区服务": "コミュニティサービス",
  "NECO优选": "NECO優選",
  "暂未开放": "暫定未開放",
  "新闻标题": "ニュースセンター",
  "新闻1标题": "創世開始、APPリリースと会員システム開放時間のお知らせ",
  "新闻1内容": "コミュニティの皆様へ：\n\n当社は8月5日24時（GMT+8）にNovai SWAPでNECO/nUSDT、USAI/nUSDT取引ペアを開放し、プラットフォームトークンとステーブルコインの創世開始を完了する予定です。\n\n同時に、NECO APPは正式に登録を開放し、グローバル会員システムをリリースします。このシステムで以下の操作が可能です：\n1. ユーザー登録とリンク共有\n2. USDTをプリペイド口座にチャージしてUSAIとし、VIP会員を購入\n3. 創世ノードと通常ノードの等額ポイント解放（NECO収益獲得）\n4. 会員推薦とチームポイント報酬獲得、自身のチーム管理\n5. 消費ポイント（会員購入、チーム報酬とノード報酬所得）のNECOへの解放\n6. NECOの瞬間交換でUSAIに変換し出金（現行バージョンはUSDTへの出金をサポート）\n7. 消費還元株式の基本機能（NECO相場確認、SWAP NECO取引ペア確認、お知らせ確認など）\n\n時間調整がある場合は、別途お知らせします。",
  "返回": "戻る",
  "消费返股": "消費還元株式 コミュニティEC",
  "全球首个": "世界初",
  "WEB3社区电商平台": "WEB3コミュニティECプラットフォーム",
  "消费": "消費",
  "赚钱": "収益化",
  "持股": "持株",
  "合伙人": "パートナー",
  "用户": "ユーザー",
  "股东": "株主",
  "不只是电商": "NECOは単なるECではありません",
  "更是社区电商": "さらにコミュニティECです",
  "共赢闭环": "ユーザー、リーダー、加盟店、Win-Winの閉ループ",
  "用户描述": "ユーザー：消費100%ポイント還元、NECO保有で値上がり益とガバナンス権を享受",
  "团长描述": "リーダー：グループ購入の組織、コミュニティ運営、コミッション+NECO追加報酬を獲得",
  "商户描述": "加盟店：値引きで精密注文と交換、0手数料決済とブランド露出を享受",
  "三方描述": "三方の収益はすべて同一のオンチェーン数式に記録され、収入と支出はリアルタイムで照合され、自己駆動型の分裂循環を形成します",
  "购物聊天": "NECO AI EC、ショッピングをチャットのように簡単に",
  "边聊边选": "チャットしながら選択",
  "聊天助手实时理解你的对话": "AIチャットアシスタントがあなたの会話をリアルタイム理解",
  "就能找到你要的东西": "一言で、あなたの欲しいものが見つかります",
  "AI优选": "AI優選",
  "的那一刻": "NECOを開いた瞬間",
  "已经在等你": "あなたに最適な商品とサービスが、もう待っています",
  "时尚分身": "ファッション分身",
  "监控价格": "良い商品探し、価格監視",
  "守护你的消费体验": "あなたの消費体験を守護",
  "三类团购机制": "3種類の団体購入メカニズム",
  "附近团": "近隣団",
  "熟人团": "知人団",
  "优选团": "優選団",
  "全球战略布局": "グローバル戦略配置",
  "使命与愿景": "NECOの使命とビジョン",
  "使命": "使命",
  "愿景": "ビジョン",
  "使命描述": "公平で透明、参加可能な自己組織化的商業システムの確立",
  "愿景描述": "世界のあらゆる角落でコミュニティ経済の光を灯すこと",
  "公告": "お知らせ",
  "铸造销毁协议": "鋳造消滅プロトコル",
  "SWAP交易": "SWAP取引",
  "NECO社区电商": "NECOコミュニティEC",
  "菜单": "メニュー",
  "安卓下载": "Androidダウンロード",
  "ios下载": "iOSダウンロード",
  "NECO下载": "NECOアプリダウンロード",
  "支持版本": "iOS Android版対応",
  "当前版本": "現在のバージョン",
  "跨链桥": "クロスチェーンブリッジ",
  "合作伙伴关系": "パートナーシップ",
  "请加入社交媒体信息": "ソーシャルメディア情報に参加してください",
  "联系我们": "連絡先",
  "版权所有（公司）": "著作権所有（会社）",
  "联系我们的邮件请填写": "ご連絡いただいたメールにご記入ください",
  "新闻": "ニュース",
  "网页直连": "Webページ直結",
  "铸造与销毁协议": "鋳造および廃棄プロトコル",
  "更多": "もっと",
  "请通过": "通過してください",
  "与我们联系": "連絡先",
  "版权所有": "著作権所有",
  "联系": "連絡",
  "智能体": "チャットロボット",

  
  "全球首个": "世界初の",
  "WEB3社区电商平台": "WEB3コミュニティECプラットフォーム",
  "消费": "消費",
  "持股": "株式保有",
  "升值": "価値上昇",
  "重新定义消费的价值": "消費の価値を再定義する",
  "让消费成为财富的起点": "消費を富の出発点に",
  "消费即拥有，分享即收益": "消費＝所有、シェア＝収益",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECOはWeb3技術に基づくスマートECインフラストラクチャで、「消費＝株式保有」メカニズムを通じて、ユーザー一人ひとりがショッピング時に実際の権益と長期リターンを得られるようにします。ここでは、消費者は単なるユーザーではなく、プラットフォームの所有者であり、エコシステムの建設者です。",
  "核心技术": "コア技術",
  "基于 Novai Chain 的二层网络": "Novai Chainを基盤とするレイヤー2ネットワーク",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco ChainはNovai Chain上に構築された高性能レイヤー2ネットワークで、",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "高頻度ECと決済向けに設計されており、平均ブロック生成時間はわずか0.2秒、TPSは50,000を超えます。",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco ChainはECのすべての消費行動とインセンティブをブロックチェーンに記録し、",
  "让商业行为具备长期可验证性与可追溯性。": "商業行動に長期的な検証可能性とトレーサビリティをもたらします。",
  "高速并行账本结构": "高速並列台帳構造",
  "智能结算与动态费用调节": "スマート決済と動的手数料調整",
  "消费凭证 NFT 化与积分资产化": "消費証明書のNFT化とポイント資産化",
  "核心特性": "コア機能",
  "链上结算": "オンチェーン決済",
  "每笔电商交易 0.2 秒确认，安全透明": "EC取引は0.2秒で確認、安全で透明性あり",
  "激励协议": "インセンティブプロトコル",
  "激励消费者、商家、渠道等为NECO做出贡献": "消費者、商家、チャネル等がNECOに貢献するようインセンティブ",
  "权益积分": "権益ポイント",
  "用户消费即持有可追踪、可变现的权益积分": "ユーザーの消費により追跡可能で現金化可能な権益ポイントを保有",
  "共建共享": "共同建設・共有",
  "首个去中心商业自治组织，共建共享NECO电商": "初の分散型商業自治組織、NECO ECを共同建設・共有",
  "主要产品": "主な製品",
  "支持电商 RWA 的高性能公链": "EC RWAをサポートする高性能パブリックチェーン",
  "稳定币、DEX、去中心信用等电商基础协议": "ステーブルコイン、DEX、分散型信用などEC基盤プロトコル",
  "同时为WEB2和WEB3用户服务的电商APP": "WEB2とWEB3ユーザーの両方にサービスするECアプリ",
  "法币和数字货币统一支付及结算体系": "法定通貨と暗号資産の統一決済・決算システム",
  "竞争优势": "競争優位性",
  "极速公链": "超高速パブリックチェーン",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0.2秒でブロック生成、百万件級同時注文・決済取引をサポート。",
  "全球合规": "グローバルコンプライアンス",
  "在全球各地通过 DAO 组织进行本地合规运营。": "世界中でDAO組織を通じて現地コンプライアンス運営を実施。",
  "电商 RWA": "EC RWA",
  "第一个将现实世界电商完全放在链上运行的平台。": "現実世界のECを完全にオンチェーンで運営する初のプラットフォーム。",
  "商业闭环": "ビジネスのクローズドループ",
  "让消费、社交与收益形成价值闭环。": "消費、ソーシャル、収益が価値のクローズドループを形成。",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "グローバル流通体系により、すべてのユーザーがブランドの発信者と収益者になれます。",
  "消费者端": "消費者側",
  "注册/消费即得积分奖励，积分每日释放为资产。": "登録/消費でポイント報酬を獲得、ポイントは毎日資産としてリリース。",
  "商家端": "商家側",
  "一键接入结算 API，设置折让比例与积分政策。": "ワンクリックで決済APIに接続、割引率とポイント政策を設定。",
  "分销端": "流通側",
  "允许全球用户参与分销，共享收益与品牌成长。": "グローバルユーザーの流通参加を許可、収益とブランド成長を共有。",
  "NECO 生态系统": "NECOエコシステム",
  "一个融合金融、科技与商业的去中心化生态。": "金融、テクノロジー、ビジネスを融合した分散型エコシステム。",
  "Neco Chain 公链": "Neco Chainパブリックチェーン",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "商用高速レイヤー2ネットワーク（Novai L2）、決済とデータ検証インフラを提供。",
  "NECO App": "NECOアプリ",
  "用户购物、签到、邀请与分销的统一入口。": "ユーザーのショッピング、チェックイン、招待、流通の統一エントリーポイント。",
  "USAI 稳定币": "USAIステーブルコイン",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "プラットフォーム内決済・決算用のステーブルコイン資産、ドル価値にアンカー。",
  "U Card 全球消费卡": "U Cardグローバル消費カード",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "オンライン・オフライン消費シーンを接続、ポイント割引とキャッシュバックをサポート。",
  "NECO AI 智能系统": "NECO AIインテリジェントシステム",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "AIによるユーザービヘイビア分析で、パーソナライズド推奨とセキュリティリスク管理を実現。",
  "消费金融该协议": "消費金融プロトコル",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "汎用分散型金融インフラを提供、EC資産流通をサポート。",
  "稳定币生态": "ステーブルコインエコシステム",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "決済、決算、クロスボーダー流通をカバーするステーブルコインネットワークを構築。",
  "团队及投资人": "チームと投資家",
  "全球化视野 · 多元化背景。": "グローバルビジョン・多様化バックグラウンド。",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "NECOチームメンバーはシンガポール、中国、UAE等地域から、EC、フィンテック、ブロックチェーン技術分野で10年以上の業界経験を持つ。",
  "投资人": "投資家",
  "运营团队": "運営チーム",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "ヨーロッパ、中東、南米の小売企業起業経験が豊富、ドバイの主要暗号資産取引所創設者、暗号通貨の熱心な信奉者",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "ドバイの不動産・小売業界で長年従事。多国籍企業の豊富な経営経験を有する。",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "OKXに勤務、企業ブランドと戦略を担当",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Novai Chain創設者、NECO技術実装を全面サポート。",
  "官方路线图": "公式ロードマップ",
  "2025 — 创世与启动": "2025 — 創世と起動",
  "2025 — 增长与市场拓展": "2025 — 成長と市場拡大",
  "2026 — 生态深化与 AI 赋能": "2026 — エコシステム深化とAI賦能",
  "上半年（Q2–Q3）": "上半期（Q2–Q3）",
  "完成白皮书、制度模型与产品原型开发": "ホワイトペーパー、制度モデル、製品プロトタイプ開発完了",
  "组织九大社区进行创世启动": "九大コミュニティを組織して創世起動を実施",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "300ノードの募集完了、NECO & USAIトークン発行、初期流動性プール追加",
  "发布 NECO APP BETA 测试版": "NECOアプリBETAテスト版リリース",
  "下半年（Q3–Q4）": "下半期（Q3–Q4）",
  "全球社区运营中心部署完成": "グローバルコミュニティ運営センター展開完了",
  "NECO 优选店铺与创世商户上线": "NECO優良店舗と創世マーチャントのローンチ",
  "推动注册用户突破 10 万": "登録ユーザー10万人突破を推進",
  "启动空投及全球电商启动大会": "エアドロップとグローバルEC起動大会を起動",
  "Q4：好货推广 & 本地电商": "Q4：良品プロモーション & ローカルEC",
  "上线「好货系统」并开放会员商家入驻": "「良品システム」ローンチ、会員商家入居開放",
  "在主要国家开通 TePay 法币支付": "主要国でTePay法定通貨決済を開始",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "中国、韓国、ベトナムの10社NECO BestローカルEC展開完了",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "海外登録ユーザー50万人突破、VIPユーザー5万人突破",
  "举办第二次社区电商大会，开放跨境卖家注册": "第2回コミュニティEC大会開催、クロスボーダー販売者登録開放",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "中東、南米、アフリカ、ヨーロッパのローカル市場拡大、サプライチェーン統合",
  "注册用户突破 100 万，VIP 用户突破 10 万": "登録ユーザー100万人突破、VIPユーザー10万人突破",
  "Q1–Q2：体系完善": "Q1–Q2：体系完備",
  "跨境卖家突破 10 万，商家数量超 10 万": "クロスボーダー販売者10万人突破、商家数10万人超",
  "举办第一届 NECO 电商生态大会": "第1回NECO ECエコシステム大会開催",
  "上线稳定币生态与信用体系": "ステーブルコインエコシステムと信用体系ローンチ",
  "注册用户突破 500 万，VIP 超过 20 万": "登録ユーザー500万人突破、VIP20万人超",
  "Q3–Q4：智能升级": "Q3–Q4：インテリジェントアップグレード",
  "获得主要国家支付牌照，全面上线法币支付服务": "主要国決済ライセンス取得、法定通貨決済サービス全面ローンチ",
  "上线 AI 选品与推荐功能": "AI商品選択・推薦機能ローンチ",
  "商家信用、积分全面上链": "商家信用、ポイントを全面的にブロックチェーン化",
  "NECO Best 优选商家突破 100 家": "NECO Best優良商家100社突破",
  "注册用户突破 1000 万，VIP 超过 50 万": "登録ユーザー1000万人突破、VIP50万人超",
  "加入 NECO": "NECOに参加",
  "消费创造财富，社区共建共享。": "消費が富を創出し、コミュニティが共に建設し共有する。",
  "一分钟带你了解NECO": "NECOを1分で解説",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECOはチェーン上の透明なリベートメカニズムを通じて、すべての消費で実質的な収益を得ることができる。",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "従来のECプラットフォームと比較して、NECOではスマートコントラクトによって比例配分され即時返金されるため、手数料0％、在庫圧迫0％である。",
  "用户与商家共享增长红利。": "ユーザーと商家が成長の利益を共有する。",
  "全球版": "グローバルバージョン",
  "中国版": "中国バージョン",

}
export default ja_JP



// WEBPACK FOOTER //
// ./src/i18n/config/ja_JP.js